import Raven from 'raven-js';
import events from '../../events.yaml';
import { createContainer } from 'usage-tracker-multi';
import { getHistory } from '../routing/history';
import { hasAcceptedCookies } from '../tracking/cookieUtils';
const APP_NAME = 'academy-public-ui';
const waitForGlobal = (window, key, timeout = 100) => {
  const wait = resolve => {
    if (window[key]) {
      resolve(window[key]);
    } else {
      setTimeout(wait.bind(this, resolve), timeout);
    }
  };
  return new Promise(wait);
};
export class UsageTrackerPublic {
  constructor() {
    this.consent = {
      allowed: false,
      categories: {
        necessary: true,
        analytics: false,
        advertisement: false,
        functionality: false
      }
    };
    this.trackerType = 'anonymous';
    this.baseTrackerConfig = {
      events,
      onError: err => {
        Raven.captureException(err);
      },
      properties: {
        namespace: APP_NAME
      }
    };
    this.container = createContainer({
      history: getHistory(),
      storeUuidOnUrl: false
    });
    this.tracker = this.createTracker(this.trackerType);
    void this.waitForCookieBannerQueue(window);
  }
  createTracker(trackerType) {
    return this.container.createTracker(Object.assign({}, this.baseTrackerConfig, {
      trackerType
    }));
  }
  waitForCookieBannerQueue(win) {
    return waitForGlobal(win, '_hsp').then(_hsp => {
      _hsp.push(['addPrivacyConsentListener', consent => {
        this.consent = consent;
        const trackerType = consent.allowed && hasAcceptedCookies() ? 'public' : 'anonymous';
        if (trackerType !== this.trackerType) {
          this.tracker = this.createTracker(trackerType);
          this.trackerType = trackerType;
        }
      }]);
    }).catch(error => {
      Raven.captureException(error);
    });
  }
  track(eventName, eventProps) {
    this.tracker.track(eventName, eventProps);
  }
  onError(err) {
    console.warn(err);
    Raven.captureException(err);
  }
}
const usageTracker = new UsageTrackerPublic();
export default usageTracker;